import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAmazonComponent } from './simple-icons-amazon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAmazonComponent ],
    exports:      [ SimpleIconsAmazonComponent ],
    bootstrap:    []
})
export class SimpleIconsAmazonModule {}
